<div class="feedback-responses">
	<div class="mb-4 flex flex-wrap items-center justify-between gap-4">
		<div class="text-base font-bold text-black">Responses : {{ templateName }}</div>
		<div class="text-sm text-red">
			<a class="cursor-pointer hover:underline" (click)="backToList()">Feedback Management</a>
			<span class="mx-1">&gt;</span>
			<span>Responses</span>
		</div>
	</div>

	<div class="mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
		<div class="w-full max-w-xs">
			<div class="relative">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
					<input matInput [(ngModel)]="searchQuery" (input)="onSearch()" placeholder="Search" class="pr-10" />
					<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
				</mat-form-field>
			</div>
		</div>
		<app-cbta-daterange-filter
			class="ml-auto"
			[startDate]="startDate"
			[endDate]="endDate"
			(dateRangeSelected)="handleDateRangeChange($event)"
		></app-cbta-daterange-filter>
	</div>

	<div class="cbta-tbl feedback-responses-tbl">
		<div class="columns">
			<div class="column col-12">
				<ngx-table
					[configuration]="configuration"
					[data]="responses"
					[columns]="columns"
					[pagination]="pagination"
					(event)="onTableChanged($event)"
					[noResultsTemplate]="noResultsTemplate"
				>
				</ngx-table>
			</div>

			<ng-template #candidateTpl let-row>
				<span class="font-bold">{{ row.candidateName }}</span>
			</ng-template>

			<ng-template #idTpl let-row>
				<span>{{ row.candidateStaffNumber }}</span>
			</ng-template>

			<ng-template #formNameTpl let-row>
				<span>{{ row.formName || "-" }}</span>
			</ng-template>

			<ng-template #formTypeTpl let-row>
				<span>{{ row.formTypeLabel || "-" }}</span>
			</ng-template>

			<ng-template #instructorTpl let-row>
				<span>{{ row.instructorName || "-" }}</span>
			</ng-template>

			<ng-template #dateTpl let-row>
				<span class="text-violet">{{ formatDate(row.submittedAt) }}</span>
			</ng-template>

			<ng-template #actionTpl let-row>
				<div class="flex justify-center">
					<button class="aa-btn" data-variant="secondary" data-size="small" (click)="viewResponse(row.id)">View</button>
				</div>
			</ng-template>

			<ng-template #noResultsTemplate>
				<td [attr.colspan]="columns.length" class="h-[180px] text-center">
					<span class="text-grey-40">No responses found.</span>
				</td>
			</ng-template>
		</div>
	</div>
</div>
